// Generated types for ProductSupplyChainAnalysisTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { NeoNodeReadAPI } from '../../shared/types/neonode';
import { TaskReadAPI, TaskWriteAPI } from '../../tasks/types/task';
import { NeoNodeReadAPISchema } from '../../shared/types/neonode';
import { TaskReadAPISchemaObject, TaskWriteAPISchemaObject } from '../../tasks/types/task';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ProductSupplyChainAnalysisTaskReadAPI extends TaskReadAPI {
}

export interface ProductSupplyChainAnalysisTaskWriteAPI extends TaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ProductSupplyChainAnalysisTaskReadAPISchema: z.ZodType<ProductSupplyChainAnalysisTaskReadAPI> = TaskReadAPISchemaObject.extend({}).passthrough();

export const ProductSupplyChainAnalysisTaskWriteAPISchema: z.ZodType<ProductSupplyChainAnalysisTaskWriteAPI> = TaskWriteAPISchemaObject.extend({}).passthrough();
